import Axios from "../config/axios";

export const requestApi = async ({
  url,
  params = {},
  data = null,
  method = "post",
  headers = {},
}) => {
  try {
    const config = {
      method: method.toLowerCase(),
      url,
      headers,
      withCredentials: true,
    };

    if (config.method === "get") {
      config.params = params;
    } else {
      config.data = data ?? params;
      if (params && Object.keys(params).length > 0) config.params = params;
    }

    const response = await Axios.request(config);
    return response.data;
  } catch (error) {
    console.error("API request failed:", {
      url,
      method,
      params,
      data,
      message: error.message,
      ...(error.response && {
        status: error.response.status,
        data: error.response.data,
      }),
    });
    throw error;
  }
};
